import clsx from 'clsx';

import styles from './Badge.module.css';

import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'success' | 'info' | 'warn' | 'danger' | 'ai';

export interface BadgeProps {
  readonly tone?: BadgeTone;
  readonly dot?: boolean;
  readonly children: ReactNode;
  readonly className?: string;
  readonly title?: string;
}

export function Badge({ tone = 'neutral', dot, children, className, title }: BadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], className)} title={title}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
